import {
  CreateEnumerationQuantityUsageDtoTypeEnum,
  CreateUpdateEnumerationQuantityDto,
  CreateUpdateEnumerationQuantityDtoTypeEnum,
  EnumerationQuantityDto,
} from '@/api/generator';

export function toCreateUpdateEnumerationQuantityDto(
  dto: EnumerationQuantityDto,
): CreateUpdateEnumerationQuantityDto {
  return {
    ...dto,
    quantityUsageType: dto.quantityUsageType ?? undefined,
    setupUsage: {
      ...dto.setupUsage,
      $type:
        CreateEnumerationQuantityUsageDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoEnumerationDtoCreateEnumerationQuantityUsageDtoPtwPtw100AppZeroApplicationShared,
    },
    evaluationUsage: {
      ...dto.evaluationUsage,
      $type:
        CreateEnumerationQuantityUsageDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoEnumerationDtoCreateEnumerationQuantityUsageDtoPtwPtw100AppZeroApplicationShared,
    },

    $type:
      CreateUpdateEnumerationQuantityDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoEnumerationDtoCreateUpdateEnumerationQuantityDtoPtwPtw100AppZeroApplicationShared,
  };
}
